var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarDropOutline = function SvgCalendarDropOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2113 12.0582C17.0302 11.9464 16.7887 12.0023 16.6679 12.1699C16.4717 12.4634 16.2453 12.7708 15.9736 13.1341C14.7811 14.755 13 17.2004 13 18.5977C13 19.6178 13.4528 20.54 14.1774 21.2107C14.9019 21.8675 15.8981 22.2867 17 22.2867C18.1019 22.2867 19.0981 21.8675 19.8226 21.1967C20.5472 20.526 21 19.6038 21 18.5837C21 17.1864 19.2189 14.755 18.0264 13.1341C17.7698 12.7848 17.5434 12.4634 17.3321 12.1699C17.3019 12.128 17.2566 12.0861 17.2113 12.0582Z",
    fill: "#0069D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4H5C3.667 4 3 4.668 3 6.004V20C3 21.333 3.667 22 5 22H13.0618C12.6351 21.3988 12.321 20.7238 12.1493 20H5V10H16.7166C16.7554 9.94714 16.7939 9.89477 16.8321 9.84293C17.2736 9.25255 17.6415 8.753 17.9604 8.27616C18.1566 8.00368 18.5491 7.91285 18.8434 8.09451C18.8992 8.12892 18.9549 8.17637 19 8.22698V6C19 4.667 18.333 4 17 4H16V2.941C16 2.314 15.667 2 15 2C14.333 2 14 2.314 14 2.941V4H8.004V3C8.004 2.333 7.67 2 7 2C6.33 2 5.998 2.333 6 3V4ZM5 8V6H17V8H5Z",
    fill: "#0069D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9198 12.5135C14.7845 12.1711 14.4781 12 14 12H13.002C12.335 11.999 12 12.332 12 13C12 13.668 12.333 14.001 13 14H13.9456C14.2559 13.502 14.5854 13.0027 14.9198 12.5135Z",
    fill: "#0069D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C7 13.668 7.333 14.001 8 14H9C9.667 14 10 13.667 10 13C10 12.333 9.667 12 9 12H8.002C7.335 11.999 7 12.332 7 13Z",
    fill: "#0069D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17C7 17.668 7.333 18.001 8 18H9C9.667 18 10 17.667 10 17C10 16.333 9.667 16 9 16H8.002C7.335 15.999 7 16.332 7 17Z",
    fill: "#0069D0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H19V9C19 9.55228 18.5523 10 18 10H16V8Z",
    fill: "#0069D0"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarDropOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-drop-outline.4ac4d8bd.svg";
export { ForwardRef as ReactComponent };